import React from "react";
import AccountPicker from "./AccountPicker";
import DatePicker from "./DatePicker";
import Table from "../../../core/components/Table/Table";
import GraphView from "./GraphView";
import { TransactionHandler } from "./TransactionHandler";
import PieChartView from "./PiechartView";

interface TransactionProps {
  // Define your prop types here
}

const Transaction: React.FC<TransactionProps> = (props) => {
  const { selectAccount, selectedAccount, transactionList } =
    TransactionHandler();
  return (
    <div
      className="overflow-y-scroll w-full"
    >
      <div className="flex flex-col h-full px-[24px]">
        <div className="flex flex-row xs:h-16 5xl:h-auto gap-3">
          <AccountPicker
            selectAccount={selectAccount}
            selectedAccount={selectedAccount}
          />
          <DatePicker />
        </div>

        <div className="flex flex-row w-full py-4 gap-5">
          <div className="flex flex-col w-8/12 gap-4">
            <GraphView />
            <Table transactionsList={transactionList} />
          </div>
          <div className="flex w flex-col w-4/12">
            <PieChartView />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Transaction;
